import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '../../api';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public static readonly baseUrl = 'api/public';

  constructor(private http: HttpClient) {}

  public getEnvironment$(): Observable<Environment> {
    return this.http.get<Environment>(`${EnvironmentService.baseUrl}/environments`);
  }
}
